import React, { useEffect, useRef, useState } from "react";


function HtmlTyper({
  text,
  chunk = 2,
  speed = 20,
  onComplete,
}) {
  const timerRef = useRef(null);
  const [displayedHtml, setDisplayedHtml] = useState("");

  useEffect(() => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }

    const units = segmentGraphemes(text ?? "");
    if (units.length === 0) {
      setDisplayedHtml("");
      onComplete?.();
      return;
    }

    const firstChunk = units.slice(0, Math.max(1, chunk)).join("");
    setDisplayedHtml(firstChunk);

    let index = Math.max(1, chunk);

    if (index >= units.length) {
      onComplete?.();
      return;
    }

    timerRef.current = setInterval(() => {
      const next = units.slice(index, index + Math.max(1, chunk)).join("");
      setDisplayedHtml((prev) => prev + next);
      index += Math.max(1, chunk);

      if (index >= units.length) {
        clearInterval(timerRef.current);
        timerRef.current = null;
        onComplete?.();
      }
    }, Math.max(0, speed));

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [text, speed, chunk, onComplete]);

  return (
    <div
      className="html-content"
      dangerouslySetInnerHTML={{ __html: displayedHtml }}
    />
  );
}

function segmentGraphemes(str) {
  if (typeof Intl !== "undefined" && Intl.Segmenter) {
    const seg = new Intl.Segmenter(undefined, { granularity: "grapheme" });
    return Array.from(seg.segment(str), (s) => s.segment);
  }
  return Array.from(str);
}

export default HtmlTyper;
